import { render, staticRenderFns } from "./MyComment.vue?vue&type=template&id=b54ca2b4"
import script from "./MyComment.vue?vue&type=script&lang=js"
export * from "./MyComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports